import React, { FC } from 'react'
import { Text, TouchableRipple, useTheme } from 'react-native-paper'
import { Container, TextHeading } from '../atoms'
import { LinearGradientContainer } from '../molecules'
import { checkIfPropsExists } from '@linqpal/models/src/helpers/objectHelpers'
import { helpers } from '@linqpal/common-frontend'
import { useTranslation } from 'react-i18next'

const { webSpecificStyle } = helpers

type DetailsType = {
  accountholderName?: string
  accountNumber?: string
  routingNumber?: string
  name?: string
}

type BanckAccountProps = {
  last: boolean
  title: string
  onPress: () => void
  details?: DetailsType
}

export const BankAccountCard: FC<BanckAccountProps> = ({
  last = false,
  title,
  onPress,
  details = {},
}): JSX.Element => {
  const { t } = useTranslation('global')
  const { colors } = useTheme()
  const blank = !checkIfPropsExists(
    details,
    'accountNumber',
    'accountholderName',
    'routingNumber',
  )

  return (
    <TouchableRipple onPress={onPress}>
      <LinearGradientContainer
        direction={t('90deg')}
        colors={blank ? ['#9BAEBC', '#9BAEBC'] : ['#68B4DC', '#7D78C6']}
        minimized
        horizontal
        style={[
          !last && { marginRight: 25 },
          {
            paddingHorizontal: 16,
            paddingVertical: 24,
            borderRadius: 8,
            maxWidth: 420,
            minWidth: 320,
            minHeight: 180,
            boxShadow: '0px 0px 20px 4px rgba(0, 0, 0, 0.12)',
            ...webSpecificStyle({
              userSelect: 'none',
            }),
          },
        ]}
        md={{ minWidth: 420 }}
      >
        {!!title && (
          <Container>
            <Text style={{ color: colors.surface, fontWeight: '600' }}>
              {title} {blank && '+'}
            </Text>
          </Container>
        )}
        <Container>
          <TextHeading style={{ fontWeight: '300', color: colors.surface }}>
            {details?.name || details?.accountholderName}
          </TextHeading>
        </Container>
        <Container minified style={{ alignSelf: 'flex-end' }}>
          {!!details?.accountNumber && (
            <TextHeading
              style={{ color: colors.surface, fontWeight: '500', fontSize: 14 }}
            >
              {t('BankManagment.checkingAccount')} {details.accountNumber}
            </TextHeading>
          )}
        </Container>
        {!!details?.routingNumber && (
          <Text
            style={{
              alignSelf: 'flex-end',
              color: colors.surface,
              fontWeight: '500',
              fontSize: 14,
            }}
          >
            {t('BankManagment.routing')} {details.routingNumber}
          </Text>
        )}
      </LinearGradientContainer>
    </TouchableRipple>
  )
}
